<template>
  <div style="margin-top:24px;">
    <div class="leftInfo">
      <div class="infonews" >
        <div class="info">
          <div class="itembottom">
            <div class="item">
              <span v-for="(item,index) in ['总会新闻','新闻动态']" :class="{ first: index === 0, active: activepxInfoIndex === index}"
                :key="index" @click="changepxInfo(index,'新闻动态',item)"><span  style="margin-right:3px"></span>{{ item }}
              </span>
              <router-link :to="`/news/views/${pxPlateIdInfo}/${pxChildPlateId}`"></router-link>
            </div>
            <div class="itemlist" v-if="pxinfos&&pxinfos.length>0">
              <ul class="list">
                <li class="fristnew">
                  <div class="dateshow">
                    <p class="day">
                      {{ pxinfos[0].addtime | dayfilter }}
                    </p>
                    <p class="yearmonth">
                      {{ pxinfos[0].addtime | yearfilter }}
                    </p>
                  </div>
                  <div class="titleshow">
                    <router-link :to="`/news/info/${pxinfos[0].plateid}/${pxinfos[0].uuid}`" tag="h3" :title="pxinfos[0].title">
                      {{ pxinfos[0].title}}
                    </router-link>
                    <p>{{ pxinfos[0].description }}</p>
                  </div>
                </li>
                <li v-for="item in pxinfos.slice(1,5)" :key="item.id">
                  <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" tag="h3" :title="item.title">
                    <i class="iconfont icon-component-full2" style="    margin-right: 11px;"></i> {{ item.title}}
                    
                  </router-link>
                  <span>{{ item.addtime | datefilter }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightIInfo">
      <div class="infonews" style="width: 507px;">
        <div class="info" style="width: 507px;">
          <div class="itembottom" style="width: 507px;">
            <div class="item">
              <span :class="{  active: true}"><span  style="margin-right:3px"></span>公示公告
              </span>
              <router-link :to="`/news/views/${plateIdNative}`"></router-link>
            </div>
            <div class="itemlist" v-if="natives&&natives.length>0"  style="width: 507px;">
              <ul class="list"  style="width: 507px;">
                <li class="fristnew">
                  <div class="dateshow">
                    <p class="day">
                      {{ natives[0].addtime | dayfilter }}
                    </p>
                    <p class="yearmonth">
                      {{ natives[0].addtime | yearfilter }}
                    </p>
                  </div>
                  <div class="titleshow">
                    <router-link :to="`/news/info/${natives[0].plateid}/${natives[0].uuid}`" tag="h3" :title="natives[0].title" style="width: 429px;">
                      {{ natives[0].title}}
                    </router-link>
                    <p style="width: 429px;">{{ natives[0].description }}</p>
                  </div>
                </li>
                <li v-for="item in natives.slice(1,5)" :key="item.id">
                  <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" tag="h3" :title="item.title">
                    <i class="iconfont icon-component-full2" style="    margin-right: 11px;"></i> {{ item.title}}
                  </router-link>
                  <span>{{ item.addtime | datefilter }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { getNewsViews, getFindcategory } from '@/request/get'
import { INFO_NEWS, EDUNEWS_LIST,NEWCENTERLIST, IP_TEST ,NEWCENTERICON_LIST,EDUNEWSICON_LIST} from '@/config'
export default {
  name: "IntegratedService",
  components: {
  },
  data() {
    return {
      IP_TEST,
      activeInfoIndex: 0,
      activepxInfoIndex:0,
      NEWCENTERICON_LIST,
      EDUNEWSICON_LIST,
      NEWCENTERLIST,
      EDUNEWS_LIST: EDUNEWS_LIST,
      INFO_NEWS: INFO_NEWS,
      infos: [],
      picItems: { picsrc: '', title: '', description: '', plateid:'' },//带图片的内容
      plateIdInfo: "",
      childPlateId:"",
      plateIdNative:"",
      pxinfos: [],
      natives:[],
      smNatives:[],
      picpxItems: { picsrc: '', title: '', description: '', plateid:'' },//带图片的内容
      pxPlateIdInfo: "",
      pxChildPlateId:"",
      
    }
  },
  filters: {
    datefilter(value) {
      return value.slice(5,10);
    },
    dayfilter(value) {
      return value.slice(8,10);
    },
    yearfilter(value) {
      return value.slice(0,7).replace(/-/g,'.');
    }
  },
  created() {
    this.changeInfo(0, '信息咨询','智慧项目'); 
    this.changepxInfo(0, '新闻动态','总会新闻'); 
    this.getNatives()
  },
  mounted() {
  },
  methods: {
    async getNewsViews(uuid,childuuid) {
      let result = await getNewsViews(uuid, 1,6,childuuid);
      result = result.data;
      this.infos = result || [];
      this.getPicItem();
    },
    changeInfo(index, name,childname) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.childPlateId = childPlate[0].uuid;
      this.getNewsViews(this.plateIdInfo,this.childPlateId);
    },    
    /**
     * 获取带图片的项
     */
    getPicItem() {
      let result = this.infos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.picItems = result.length > 0 && result[0];
    },
    
    async getpxNewsViews(uuid,childuuid) {
      let result = await getNewsViews(uuid, 1,6,childuuid);
      result = result.data;
      this.pxinfos = result || [];
      this.getpxPicItem();
    },

    changepxInfo(index, name,childname) {
      this.activepxInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.pxPlateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.pxChildPlateId = childPlate[0].uuid;
      this.getpxNewsViews(this.pxPlateIdInfo,this.pxChildPlateId);
    },
    /**
     * 获取带图片的项
     */
    getpxPicItem() {
      let result = this.pxinfos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.pxPicItems = result.length > 0 && result[0];
    },
    async getNatives(){
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == '通知公告');
      this.plateIdNative = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == '公示公告');
      let result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data.concat(result.data);
      this.natives = result || [];
      childPlate = plate[0].CategoryChildren.filter(item => item.name == '声明公告');
      result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data;
      this.smNatives = result || [];
    }
  }
};
</script>
<style scoped>
.infonews{
  width: 735px;;
  height: 391px;
  /* padding-left: 15px; */
  background: #FFFFFF;
  display: inline-block;
  /* position: absolute; */
  /* margin-left: 17px; */
}
.infonews>.info>.itembottom{
  width: 735px;;
}
.infonews>.info>.itembottom{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.infonews>.info>.itembottom>.item{
  position: relative;
  margin-bottom: 6px;
  height: 55px;
  border-bottom: 1px solid  #EFF1F4;;
  display: flex;
  justify-content: start;
  text-align: center;
  background: #FFFFFF;
  background-image: url(/static/img/title.png);
  background-repeat: no-repeat;
  background-position-y: 15px;
  padding-left: 39px;
}
.infonews>.info>.itembottom>.item>span {
  height: 50px;
  /* margin-right: 53px; */
  font-size: 22px;
  margin-right: 69px;
  color: #000;
  width: 92px;
    line-height: 50px;
}
.infonews>.info>.itembottom>.item>span.active {
  color: #004FB7;
  font-weight: 600;
  border-bottom: 5px solid #0041BE;
  height: 52px;
/* background: url(/static/img/tab-bg.png); */
}
.infonews>.info>.itembottom>.item>a{
  position: absolute;
  padding-right: 25px;
  right:6px;
  height: 58px;
  font-size: 14px;
  
  font-weight: 500;
  font-weight: normal;
  color: #999999;
  line-height: 58px;
  background: url(/static/img/gengduo1.png) no-repeat 12px 12px;
  background-position: center right;
}
.infonews>.info>.itembottom>.itemlist{
  width:735px;;
  height:304px;
  /* display: flex; */
  justify-content: start;
  padding:16px 0px 0 0px;
}
.infonews>.info>.itembottom>.itemlist>.list{
    display: block;
    flex-direction: column;
    justify-content: start;
    overflow: hidden;
}
.infonews>.info>.itembottom>.itemlist>.list>li{
  height: 55px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.infonews>.info>.itembottom>.itemlist>.list>li>h3{
  width: 637px;
  height: 55px;
  margin-right: 55px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  line-height: 55px;
  -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  /* margin-left: 10px; */
}
.infonews>.info>.itembottom>.itemlist>.list>li>span {
  width: 150px;
  height: 55px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  line-height: 55px;
  text-align: right;
}
.infonews>.info>.itembottom>.itemlist>.list>.news{
  display: block;
  height: 211px;
}
.infonews>.info>.itembottom>.itemlist>.news>.itemright{
  display: inline-block;
  width: 577px;
  margin-left: 22px;
}
.itemright h3{
  font-size: 18px;
  font-weight: 600;
 
color: #333333;
line-height: 26px;
}
.itemright p{
  height: 119px;
  font-size: 18px;
  
  font-weight: 400;
  color: #333;
  line-height: 29px;
  margin-top: 6px;
  word-break: break-all;
-webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    /* display: -webkit-box; */
    overflow: hidden;
}
.leftInfo{
  display: inline-block;
  width: 735px;
}
.rightIInfo{
  display: inline-block;
  width: 507px;
  height: 391px;
  position: absolute;
  background-color: #FFFFFF;
  margin-left: 60px;
  /* padding: 15px 0 15px 0; */
}
.rightIInfo .news .title{
  font-size: 24px;
  
   
  color: #333333;
  line-height: 32px;
  height: 32px;
  padding-left: 44px;
  background: url(/static/img/gongg.png);
  background-repeat: no-repeat;
  margin-bottom: 10px;
}
.rightIInfo .news .title a{
  position: absolute;
  padding-right: 25px;
  right: 38px;
  height: 32px;
  font-size: 14px;
  
  font-weight: 500;
  font-weight: normal;
  color: #999999;
  line-height: 32px;
  background: url(/static/img/gengduo.png) no-repeat 12px 12px;
  background-position: center right;
}
.rightIInfo .news .list{
  /* padding-left:17px; */
  height: 480px;
}
.rightIInfo .news .list li{
  /* padding-left:17px; */
  height: 44px;
  display: flex;
  justify-content: start;
  align-items: center;

}

.rightIInfo .news .list li a{
  cursor:pointer;
  line-height: 44px;
  font-size: 18px;
  width: 335px;
  
  font-weight: 400;
  color: #333333;
  word-break: break-all;
  -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    /* display: -webkit-box; */
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.rightIInfo .news .list li span {
  width: 150px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  line-height: 44px;
  text-align: right;
}
.rightIInfo .news .smtitle{
  background: url(/static/img/shengm.png) no-repeat;
  margin-bottom: 21px;
}
.smnews h3{
  line-height: 44px;
  height: 44px;
  font-size: 18px;
  width:100%;
  text-align: center;
  
  font-weight: 600;
  color: #333333;
  word-break: break-all;
  -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    /* display: -webkit-box; */
    overflow: hidden;
}
.fristnew{
  height: 73px !important;
  background: #F3F3F3;
  padding:8px;
  display: flex;
}
.fristnew .dateshow {
  width: 72px;
height: 72px;
text-align: center;
display: inline-block;
margin-right: 14px;;
}
.fristnew .dateshow .day{
  font-size: 30px;
  height: 49px;
  line-height: 49px;
font-weight: bold;
color: #3767E7;
}

.fristnew .dateshow .yearmonth{
  font-size: 14px;
font-weight: 500;
color: #808080;
}
.fristnew .titleshow{
  height: 64px;
}
.fristnew .titleshow h3{
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  line-height: 24px;
  width: 655px;
  -webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.fristnew .titleshow p{
  height: 14px;
font-size: 14px;
font-weight: 500;
color: #808080;
margin-top: 24px;
width: 655px;
-webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
</style>
